import { resolveApiUrls } from '../resolveApiUrls'

const { entityApiUrl } = resolveApiUrls({
  stage: import.meta.env.VITE_STAGE,
  configuredApiBaseUrl: import.meta.env.VITE_API_BASE_URL,
})

export default entityApiUrl
